/**
 * Checkbox
 * Styled checkbox wrapper
 */
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox as MuiCheckbox,
} from '@mui/material';
import React from 'react';

import Icon from '@components/Icon/Icon';

import useUniqueId from '@hooks/useUniqueId';

interface CheckboxProps {
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | null;
  label?: React.ReactNode;
  checked: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  defaultOnly?: boolean;
  name?: string;
  labelPlacement?: 'end' | 'start' | 'bottom' | 'top';
}

const Checkbox: React.FC<CheckboxProps> = ({
  onChange,
  label = '',
  checked = false,
  error = false,
  defaultOnly = false,
  name = '',
  labelPlacement,
  helperText,
  ...rest
}) => {
  const uniqueID = useUniqueId('check-box');

  function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    if (onChange) {
      onChange(event);
    }
  }

  return (
    <FormControl
      required
      error={error}
      component="fieldset"
      variant="standard"
      sx={{ width: 'auto' }}
    >
      <FormControlLabel
        control={
          <MuiCheckbox
            onChange={handleChange}
            {...{
              defaultChecked: defaultOnly ? checked : undefined,
              checked: defaultOnly ? undefined : checked,
            }}
            id={name || uniqueID}
            name={name}
            {...rest}
            checkedIcon={
              <Icon
                style={{
                  fontSize: '20px',
                }}
                name="square-check"
                type="fas"
              />
            }
            icon={
              <Icon
                style={{
                  fontSize: '20px',
                }}
                name="square"
                type="far"
              />
            }
          />
        }
        label={label}
        labelPlacement={labelPlacement ?? 'end'}
        sx={{
          alignItems: 'flex-start',
          '& .MuiFormControlLabel-label': {
            marginTop: '7px',
          },
        }}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default Checkbox;
